module.exports = __webpack_public_path__ + "static/truckslider-03-min-93a238e0cdbd2b0cdaf80eb11177e2f5.jpg";